import React from "react"

export const EmptyRedesign = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_22_6040" fill="white">
      <path d="M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z" />
    </mask>
    <path
      d="M4 0V2H16V0V-2H4V0ZM20 4H18V16H20H22V4H20ZM16 20V18H4V20V22H16V20ZM0 16H2V4H0H-2V16H0ZM4 20V18C2.89543 18 2 17.1046 2 16H0H-2C-2 19.3137 0.686291 22 4 22V20ZM20 16H18C18 17.1046 17.1046 18 16 18V20V22C19.3137 22 22 19.3137 22 16H20ZM16 0V2C17.1046 2 18 2.89543 18 4H20H22C22 0.686292 19.3137 -2 16 -2V0ZM4 0V-2C0.686292 -2 -2 0.686291 -2 4H0H2C2 2.89543 2.89543 2 4 2V0Z"
      fill="#9FA0A7"
      mask="url(#path-1-inside-1_22_6040)"
    />
  </svg>
)
